import { Dispatch, FC } from 'react';
import Button from 'antd/lib/button/button';
import notification from 'antd/lib/notification/index';

import { store } from 'App';
import { setActiveChatIdAction } from 'store/actions/messagesActions';
import history from 'utils/history';
import { ERoutePaths } from 'types/routes/enums';

interface MessageNotificationProps {
  name: string,
  id: string
  notificationId: string;
}

const MessageNotification: FC<MessageNotificationProps> = ({ name, id, notificationId }) => {
  const dispatch = store.dispatch as typeof store.dispatch | Dispatch<any>;

  const handleViewMessage = () => {
    dispatch(setActiveChatIdAction({ id }));
    notification.destroy(notificationId);
    history.push(ERoutePaths.Messages);
  };

  return (
    <div className="pl-2.5">
      <p>{name}</p>
      <Button type="link" className="h-6 p-0" onClick={handleViewMessage}>
        <span className="text-13 font-semibold text-blue-50 clickable">Your have a new&nbsp;message!</span>
      </Button>
    </div>
  );
};

export default MessageNotification;
